import React from "react";
import { Router } from "@reach/router";

import "./App.css";
import "./Fonts.css";

/**
|--------------------------------------------------
| Pages
|--------------------------------------------------
*/

import FactoryDetailPage from "./pages/FactoryDetail";
import SensorBoardDetailPage from "./pages/SensorBoardDetail";
import HomePage from "./pages/Home";

import SignoutPage from "./pages/Signout";
import SigninPage from "./pages/SignIn";
import DealerDetailPage from "./pages/DealerDetail";

import SignupPage from "./pages/Signup";

function App() {
  return (
    <Router>
      <HomePage path="/" />

      {/* AUTH ─────────────────────────────────────Responsesive─────────────────────────────────────────── */}
      <SigninPage path="/signin" />
      <SignoutPage path="/signout" />
      <SignupPage path="/signup/:signupToken" />

      {/* DEALER ─────────────────────────────────────Responsesive─────────────────────────────── */}
      <DealerDetailPage path="/:dealerID" />

      {/* FACTORY ──────────────────────────────────────────────────────────────────────────────── */}
      <FactoryDetailPage path="/:dealerID/:factoryID" />
      <SensorBoardDetailPage path="/:dealerID/:factoryID/:sensorID" />
    </Router>
  );
}

export default App;
